define('utils/template',['jquery', 'lib/mustache'], function ($, Mustache) {
	
	/**
	 * Function to render templates with mustache
	 * 
	 * $.render(template_key, data)
	 * string: template_key: Key to retrieve the template, is used with $.getCode()
	 * obj: data: data to parse to the template 
	 */
	jQuery.extend({
		render : function (template_key, data) {
			var html = this.getCode(template_key);
			return Mustache.render(html, data);
		},
		
		/**
		 * Get HTML Code from comment tag
		 * Deze code bevindt zich in #code en dan div met class 'key'
		 * De HTML staat in Comments zodat deze niet geparsed wordt
		 * 
		 * @param key van de Code
		 * @returns html
		 */
		getCode : function (key) {
			var code = $('#code').find('.'+key)[0];
			for(var i = 0; i < code.childNodes.length; i++) {
				if(code.childNodes[i] instanceof Comment) {
					return code.childNodes[i].data;
				}
			}
			return '';
		},
	});
});
